/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import Boton from "../boton";

export default function FormularioBoton({ config, loader, botonCallback }) {
  const [botonClickeado, setBotonClickeado] = useState(false);

  function onClick() {
    setBotonClickeado(true);
    botonCallback(config.callback, config.validar);
  }

  // Cuando apaga el loader, resetea el botón clickeado
  useEffect(() => {
    if (!loader) {
      setBotonClickeado(false);
    }
  }, [loader]);

  return (
    <Boton
      callback={onClick}
      loader={loader && botonClickeado}
      disabled={loader}
      confirmacion={config.confirmacion}
      texto={config.texto}
      icono={config.icono}
      verde={config.verde}
      rojo={config.rojo}
      amarillo={config.amarillo}
      negro={config.negro}
      transparente={config.transparente}
      ancho
    >
      {config.etiqueta}
    </Boton>
  );
}
